import calculateIndexMap from "./calculateIndexMap";
import calculateIndexMap2 from "./calculateIndexMap2";

/*

This function will split array into n(no of columns) parts.

*/
const splitArray = (items, options) => {
  const n = Math.floor(items.length / options.columns);
  const extra = items.length - n * options.columns;

    let middle = options.columns%2===0?(options.columns / 2)+1:Math.ceil(options.columns / 2);
    if(options.columns===2){
      middle=1
    }
    const indexMap = options.balance_columns?calculateIndexMap(extra, middle):calculateIndexMap2(extra,middle);
    let [...arr] = items;
    let res = [];
    let i = 1;
    while (arr.length) {
      if (indexMap[i] === true) {
        res.push(arr.splice(0, n + 1));
        i = i + 1;
      } else {
        res.push(arr.splice(0, n));
        i = i + 1;
      }
    }
    let ans=res
    return {ans,indexMap};
  };
export default splitArray  